var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCyprus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#FCFCFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0435 13.9131C24.5566 13.9131 23.9537 13.9131 22.9566 13.9131C22.9566 17.7551 19.842 20.8696 16.0001 20.8696C12.158 20.8696 9.0436 17.7551 9.0436 13.9131C8.3711 13.9131 7.62904 13.9131 6.95667 13.9131C6.95667 18.0516 9.73642 21.5408 13.5308 22.6153C13.1148 23.4056 13.1782 24.4005 13.7724 25.1421C14.5529 24.5165 15.361 23.8689 16.0465 23.3197C16.732 23.869 17.5401 24.5166 18.3205 25.1421C18.9207 24.3931 18.9797 23.3856 18.5499 22.5915C22.3027 21.4906 25.0435 18.0221 25.0435 13.9131V13.9131Z",
    fill: "#6DA544"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4348 13.2174C10.4348 13.2174 10.4348 16.6957 13.9131 16.6957L14.6087 17.3913H16C16 17.3913 16.6956 15.3044 18.0869 15.3044C18.0869 15.3044 18.0869 13.9131 19.4783 13.9131C20.8696 13.9131 21.5652 13.9131 21.5652 13.9131C21.5652 13.9131 20.8696 11.1304 24.3478 9.0435L22.9565 8.34787C22.9565 8.34787 18.0869 11.8261 14.6087 11.1305V12.5218H13.2174L12.5218 11.8262L10.4348 13.2174Z",
    fill: "#FFDA44"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCyprus);
export default __webpack_public_path__ + "static/media/cyprus.30d02c9c.svg";
export { ForwardRef as ReactComponent };